/**
 * MeetingPlatformLogo
 * ════════════════════
 * Crisp SVG brand logos for every meeting platform.
 * No external dependencies — pure inline SVG.
 */
import React from 'react';

/* ── Google Meet ─────────────────────────────────────── */
function GoogleMeetLogo({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill="#fff"/>
      <rect x="6" y="14" width="24" height="20" rx="4" fill="#00897B"/>
      <polygon points="31,18 43,24 31,30" fill="#00BCD4"/>
      <circle cx="18" cy="24" r="5.5" fill="#fff"/>
      <circle cx="18" cy="24" r="2.5" fill="#00897B"/>
    </svg>
  );
}

/* ── Zoom ────────────────────────────────────────────── */
function ZoomLogo({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill="#2D8CFF"/>
      <rect x="5" y="14" width="22" height="20" rx="4" fill="#fff"/>
      <polygon points="28,17 43,10 43,38 28,31" fill="#fff"/>
      <rect x="8" y="17" width="16" height="14" rx="2.5" fill="#2D8CFF"/>
    </svg>
  );
}

/* ── Microsoft Teams ─────────────────────────────────── */
function TeamsLogo({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill="#5059C9"/>
      <rect x="10" y="13" width="28" height="5" rx="2.5" fill="#fff"/>
      <rect x="21.5" y="13" width="5" height="24" rx="2.5" fill="#fff"/>
      <circle cx="37" cy="16" r="5" fill="#E8E8F8"/>
      <path d="M29 36 C29 30 34 27 37 27 C40 27 45 30 45 36 Z" fill="#7B83EB"/>
    </svg>
  );
}

/* ── Custom / Generic Link ───────────────────────────── */
function CustomLinkLogo({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill="#374151"/>
      <path d="M17 28 L14 31 C11.5 33.5 11.5 37.5 14 40 C16.5 42.5 20.5 42.5 23 40 L27 36"
        stroke="#fff" strokeWidth="3.5" strokeLinecap="round" fill="none"/>
      <path d="M31 20 L34 17 C36.5 14.5 36.5 10.5 34 8 C31.5 5.5 27.5 5.5 25 8 L21 12"
        stroke="#fff" strokeWidth="3.5" strokeLinecap="round" fill="none"/>
      <path d="M16 32 L32 16" stroke="#fff" strokeWidth="3.5" strokeLinecap="round"/>
    </svg>
  );
}

const LOGOS = {
  google_meet: GoogleMeetLogo,
  zoom:        ZoomLogo,
  teams:       TeamsLogo,
  custom:      CustomLinkLogo,
};

export default function MeetingPlatformLogo({ id, size = 36, style = {}, className = '' }) {
  const Logo = LOGOS[id] || CustomLinkLogo;
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: size,
        height: size,
        lineHeight: 0,
        borderRadius: Math.round(size * 0.22),
        overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,.15)',
        ...style,
      }}
    >
      <Logo size={size} />
    </span>
  );
}

export { GoogleMeetLogo, ZoomLogo, TeamsLogo, CustomLinkLogo };
